var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClipboardIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Clipboard_icon_svg__clip0_1_50)",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.786 259.25H282.214c-26.24 0-47.512 21.272-47.512 47.512v538.524c0 26.24 21.272 47.512 47.512 47.512h435.572c26.24 0 47.512-21.272 47.512-47.512V306.762c0-26.24-21.272-47.512-47.512-47.512z",
    fill: "#BE7F4D",
    stroke: "#806B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.155 278.643H322.833c-9.178 0-16.619 7.44-16.619 16.619V746.69c0 9.179 7.441 16.619 16.619 16.619h354.322c9.178 0 16.619-7.44 16.619-16.619V295.262c0-9.179-7.441-16.619-16.619-16.619z",
    fill: "#fff",
    stroke: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.155 313.917H322.833c-9.178 0-16.619 7.44-16.619 16.619v451.428c0 9.179 7.441 16.619 16.619 16.619h354.322c9.178 0 16.619-7.44 16.619-16.619V330.536c0-9.179-7.441-16.619-16.619-16.619z",
    fill: "#fff",
    stroke: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 183.226c20.993 0 38.012-17.018 38.012-38.012 0-20.993-17.019-38.012-38.012-38.012-20.993 0-38.012 17.019-38.012 38.012 0 20.994 17.019 38.012 38.012 38.012z",
    fill: "#CAE0E3",
    stroke: "#43B3BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.952 238.726H386.06l20.107-57.071a35.601 35.601 0 0133.583-23.774h120.512a35.601 35.601 0 0133.583 23.774l20.107 57.071z",
    fill: "#A0D1D6",
    stroke: "#3DA2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.298 239.333h241.404c9.822 0 17.81 7.976 17.81 17.81v60.238c0 19.655-15.952 35.607-35.607 35.607H397.119c-19.655 0-35.607-15.952-35.607-35.607v-60.238c0-9.822 7.976-17.81 17.809-17.81h-.023z",
    fill: "#95C2C7",
    stroke: "#2A848E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 309.94v43.036M428.786 309.94v43.036M571.214 309.94v43.036",
    stroke: "#2A848E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.167 474.19l18.774 18.774s18.773-37.547 37.547-56.321M393.167 572.738l18.774 18.774s18.773-37.548 37.547-56.322M393.167 671.298l18.774 18.773s18.773-37.547 37.547-56.321",
    stroke: "#46C65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.048 464.798h90.785M516.048 563.357h90.785M516.048 661.905h90.785",
    stroke: "#006C78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.298 272.012h147.404",
    stroke: "#A0D1D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Clipboard_icon_svg__clip0_1_50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIcon);
export default ForwardRef;